export default __webpack_public_path__ + "static/media/Y_Ygara.8454c0d3.mp3";